<template>
  <div class="product-tree-product-card">
    <div class="card mb-3">
      <div class="card-content">
        <div class="content">

          <!-- Unlimited subscription -->
          <product-detail-unlimited-subscription
            :product-tree="productTree"
            :add-to-cart-btn="addToCartBtn"
            v-if="productTree.product_type === 'UnlimitedSubscription'"
          />

          <!-- Subscription -->
          <product-detail-subscription
            :product-tree="productTree"
            :add-to-cart-btn="addToCartBtn"
            v-if="productTree.product_type === 'Subscription'"
          />

          <!-- Tickets book -->
          <product-detail-tickets-book
            :product-tree="productTree"
            :add-to-cart-btn="addToCartBtn"
            v-if="productTree.product_type === 'TicketsBook'"
          />

          <!-- Multi tickets book -->
          <product-detail-multi-tickets-book
            :product-tree="productTree"
            :add-to-cart-btn="addToCartBtn"
            v-if="productTree.product_type === 'MultiTicketsBook'"
          />

          <!-- Product -->
          <product-detail-product
            :product-tree="productTree"
            :add-to-cart-btn="addToCartBtn"
            v-if="productTree.product_type === 'Product'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductDetailUnlimitedSubscription
  from "@/components/partial/productTree/productDetail/ProductDetailUnlimtedSubscription";
import ProductDetailTicketsBook from "@/components/partial/productTree/productDetail/ProductDetailTicketsBook";
import ProductDetailSubscription from "@/components/partial/productTree/productDetail/ProductDetailSubscription";
import ProductDetailMultiTicketsBook
  from "@/components/partial/productTree/productDetail/ProductDetailMultiTicketsBook";
import ProductDetailProduct from "@/components/partial/productTree/productDetail/ProductDetailProduct.vue";

export default {
  name: "ProductTreeProductCard",
  components: {
    ProductDetailProduct,
    ProductDetailMultiTicketsBook,
    ProductDetailSubscription,
    ProductDetailTicketsBook,
    ProductDetailUnlimitedSubscription
  },
  props: {
    productTree: Object,
    addToCartBtn: {
      type: Boolean,
      default: true
    }
  }
}
</script>
